<ng-container *ngIf="isEdit">
  <tix-event-info
    *ngIf="
      (selectedEventData$ | async) && (eventVenueList$ | async)?.length;
      else loading
    "
    [selectedEventData]="selectedEventData$ | async"
    [eventTypeList]="businessEventTypes$ | async"
    [statusLists]="businessStatusLists$ | async"
    [campaignType]="campaignType$ | async"
    [eventTicketLists]="eventTicketConfigurationList$ | async"
    [eventVenueList]="eventVenueList$ | async"
    [userData]="userState$ | async"
  ></tix-event-info>

  <ng-template #loading>
    <tix-loading-state
      [isLoading]="true"
      [hasError]="false"
      type="inline"
      loadingText="Loading Event"
      loadingSubText="Fetching event information..."
    ></tix-loading-state>
  </ng-template>
</ng-container>

<tix-event-info
  *ngIf="!isEdit"
  [selectedEventData]="selectedEventData$ | async"
  [eventTypeList]="businessEventTypes$ | async"
  [statusLists]="businessStatusLists$ | async"
  [campaignType]="campaignType$ | async"
  [eventTicketLists]="eventTicketConfigurationList$ | async"
  [eventVenueList]="eventVenueList$ | async"
  [userData]="userState$ | async"
></tix-event-info>
